export default __webpack_public_path__ + "static/media/Sigmoid_Set_up_Female.6007b2c6.png";